import React from 'react';

export const i18nContext = React.createContext({});

export const I18nProvider = ({ children, locale, translations }) => {
  const interpolate = (val, args) => {
    if (typeof args !== 'undefined') {
      Object.entries(args).forEach(([k, v]) => (val = val.replace(`{${k}}`, v)));
    }
    return val;
  };

  const t = (key, args) => {
    if (typeof translations[locale] === 'undefined') return key;
    let val = translations[locale][key];
    if (!val) {
      val = key;
    }
    return interpolate(val, args);
  };

  // convenience method to pull the translation key from an object that has properties like 'i18n' or a locale string
  // config.json entries don't consistently include every locale (e.g. many only have 'en' and 'es'), so a missing
  // or blank value for the current locale falls back to 'i18n' (the generic default), then 'en', instead of rendering blank
  const xt = (keyVals, args) => {
    if (!keyVals) return '';
    if (typeof keyVals === 'string') return interpolate(keyVals, args);
    for (let k of [locale, 'i18n', 'en']) {
      if (keyVals[k]) {
        return interpolate(keyVals[k], args);
      }
    }
    return '';
  };

  return <i18nContext.Provider value={{ t, xt, locale }}>{children}</i18nContext.Provider>;
};

export const I18nConsumer = i18nContext.Consumer;
